import { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { FAQ_DATA } from '../data/faq';
import styles from './FAQ.module.css';

export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className={styles.section}>
      <div className="wrap">
        <div className="section-header">
          <div className="section-label">FAQ</div>
          <h2>Common Questions</h2>
          <p>Everything you need to know about PCCheckr.</p>
        </div>

        <div className={styles.grid}>
          {FAQ_DATA.map((item, index) => (
            <div 
              key={index} 
              className={`${styles.item} ${openIndex === index ? styles.open : ''}`}
              onClick={() => toggle(index)}
            >
              <div className={styles.question}>
                <h3>{item.question}</h3>
                <div className={styles.toggle}>
                  {openIndex === index ? <Minus size={20} /> : <Plus size={20} />}
                </div>
              </div>
              <div className={styles.answer}>
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
